import styled from "styled-components";

export const SOnboardingForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: auto;
  margin-top: 56px;
`;
